import React from 'react'
import type { FC, ReactNode } from 'react'
import Link from 'next/link'

interface BadgeProps {
  title: string
  href: string
  variant?: 'primary' | 'secondary'
  icon?: ReactNode
}

export const Badge: FC<BadgeProps> = ({ title, href, variant = 'primary', icon }) => {
  const baseClasses =
    'flex items-center px-3 py-1 rounded-full text-sm font-medium transition-colors'
  const variantClasses = {
    primary: 'bg-primary text-primary-foreground hover:bg-primary/90',
    secondary: 'bg-slate-50 border border-slate-200 text-slate-900 hover:bg-slate-100',
  }

  return (
    <Link href={href} className={`${baseClasses} ${variantClasses[variant]}`}>
      {icon && <span className="mr-1.5">{icon}</span>}
      {title}
    </Link>
  )
}
